module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('img', {
    attrs: {
      "src": _vm.agentStaffAvatar,
      "alt": ""
    }
  }), _vm._v(_vm._s(this.agentStaffName) + "\n            ")])]), _vm._v(" "), _c('h1', [_vm._v("邀请你注册使用快批")]), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "usernamewrapper"
  }, [_c('div', {
    staticClass: "imgwrapper"
  }, [_c('img', {
    attrs: {
      "src": require('../assets/account.png')
    }
  })]), _vm._v(" "), _c('input', {
    ref: "username",
    staticClass: "username",
    attrs: {
      "type": "email",
      "placeholder": "中国大陆手机/邮箱"
    },
    on: {
      "blur": _vm.limitcontent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "passwordwarp"
  }, [_c('div', {
    staticClass: "imgwrapper"
  }, [_c('img', {
    attrs: {
      "src": require('../assets/password.png')
    }
  })]), _vm._v(" "), _c('input', {
    ref: "password",
    staticClass: "password",
    attrs: {
      "type": "number",
      "placeholder": "填写验证码"
    }
  }), _vm._v(" "), _c('input', {
    ref: "passwordbtn",
    staticClass: "passwordbtn",
    attrs: {
      "type": "button",
      "value": "获取验证码"
    },
    on: {
      "click": _vm.getcode
    }
  })]), _vm._v(" "), _c('div', {
    ref: "verificate",
    staticClass: "verificate"
  }), _vm._v(" "), _c('input', {
    ref: "startbtn",
    staticClass: "registerbtn",
    attrs: {
      "type": "button",
      "disabled": false,
      "value": "确定"
    },
    on: {
      "click": _vm.submit
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-109a8896","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 297
// module chunks = 1